import cn from "classnames"

import { Sizes } from "../interfaces"
import { SIZES, STYLES } from "../constant"

import styles from "./styles.module.scss"

interface Props {
    size?: Sizes
    className?: string
    children: string
    isAdaptive?: boolean
    isInverted?: boolean
    isLink?: boolean
    isMenu?: boolean
}

export function NonImgAvatar({
    children,
    size,
    className,
    isAdaptive = false,
    isInverted = false,
    isLink = false,
    isMenu,
}: Props) {
    return (
        <div
            className={cn(styles.userAvatar, className, {
                [styles.isAdaptive]: isAdaptive,
                [styles.isInverted]: isInverted,
                [styles.isLink]: isLink,
                [styles.isMenu]: isMenu,
            })}
            style={{
                ...(size && SIZES[size] ? SIZES[size] : {}),
                ...(size && STYLES[size] ? STYLES[size] : {}),
            }}
        >
            {size === "L" ? children : children.substring(0, 1)}
        </div>
    )
}
